import config from '@/config';
import axios from 'axios';

export const BACKEND = axios.create({
  baseURL: config.remotes.backend,
  auth: {
    username: config.remotes.username,
    password: config.remotes.password,
  },
});

export const NAME_ORGANITHATION = axios.create({
  baseURL: config.organithation.url,
  headers: {
    Authorization: 'token ' + config.organithation.token,
  },
});

export const FIO = axios.create({
  baseURL: config.fio.url,
  headers: {
    Authorization: 'token ' + config.fio.token,
  },
});

export const ADDRESS = axios.create({
  baseURL: config.address.url,
  headers: {
    Authorization: 'Token ' + config.address.token,
  },
});

export const CITIES = axios.create({
  baseURL: config.cities.url,
});

export const MATRIX_BACKEND = axios.create({
  baseURL: config.matrixBackend.url,
  headers: {
    'Content-Type': 'application/json',
    'X-Client-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
  },
});

export const B2B_BACKEND = axios.create({
  baseURL: config.b2bBackend.url,
  headers: {
    'Content-Type': 'application/json',
    token: 'eb80c64a-0c42-4075-8a51-8dfa06faa0a9',
    userId: '3b76a211-38ad-4169-9c6a-f52b114a40f3',
  },
});
